import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OrbitFormClaimService } from '../../features/orbit/book-claim/services/orbit-form-claim.service';
import { AppInfo } from '../../global/environment';

export const orbitStepGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const orbitFormClaimService = inject(OrbitFormClaimService);
  const planNumber = route.parent?.params['planNumber'];

  const currentStep = router.url.split('/').pop();
  const targetStep = state.url.split('/').pop();

  if (!currentStep) {
    if (targetStep?.includes('payment')) {
      return navigateToConfirmYourDetails(orbitFormClaimService, router, planNumber);
    }
    return true; // Let it through if we don't have enough info yet (initial load)
  }

  const stepsPastFaultDetails = [
    'repair-details',
    'smart-fix-video-guides',
    'confirm-your-details',
    'service-options',
    'book-engineer',
    'book-collection',
    'confirmation',
  ];
  const stepsPastRepairDetails = [
    'confirm-your-details',
    'service-options',
    'book-engineer',
    'book-collection',
    'confirmation',
  ];

  const stepsPastPayment = ['book-engineer', 'book-collection', 'confirmation'];

  const checkPointMapping: Record<string, string[]> = {
    'smart-fix': stepsPastFaultDetails,
    'product-number': stepsPastFaultDetails,
    'model-number': stepsPastFaultDetails,
    'fault-details': stepsPastFaultDetails,
    'repair-details': stepsPastRepairDetails,
    payment: stepsPastPayment,
  };

  if (checkPointMapping[targetStep!]?.includes(currentStep!)) {
    if (targetStep?.includes('payment')) {
      return navigateToConfirmYourDetails(orbitFormClaimService, router, planNumber);
    }

    window.location.href = `${AppInfo.Environment.claimsURL}/my-plans/${planNumber}/claims`;

    return false;
  }

  if (currentStep === 'confirmation') {
    window.location.href = `${AppInfo.Environment.claimsURL}/my-plans/${planNumber}/claims`;
    return false;
  }

  return true;
};

function navigateToConfirmYourDetails(
  orbitFormClaimService: OrbitFormClaimService,
  router: Router,
  planNumber: string
) {
  orbitFormClaimService.currentStep.set('confirm-your-details');
  router.navigate(['/', planNumber, 'orbit', 'confirm-your-details']);
  return false;
}
